import React, { useState } from 'react';
import { CategoryProduct } from '../../../domain/entities/CategoryProduct';
import ButtonTabItem from './ButtonTabItem';
import { ProductItem } from '../../../domain/entities/ProductItem';

interface TabsComponentProps {
  onCategoryChange: (categorySlug: string, productItems: ProductItem[], category: CategoryProduct) => void;
  categories: CategoryProduct[];
}

const TabsComponent: React.FC<TabsComponentProps> = ({ onCategoryChange, categories }) => {
  const [activeTab, setActiveTab] = useState<number | null>(null);

  const handleTabClick = (tabId: number, categorySlug: string, productItems: ProductItem[], category: CategoryProduct) => {
    setActiveTab(tabId);
    onCategoryChange(categorySlug, productItems, category);
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-2">
      {categories.map((tab) => (
        <ButtonTabItem
          key={tab.id}
          category={tab}
          isActive={activeTab === tab.id}
          onTabClick={handleTabClick}
        />
      ))}
    </div>
  );
};

export default TabsComponent;